
import request from '@/utils/request'
/*
npm菜单管理相关的API请求函数
*/
const api_name = '/portal/web/api/article/'

export default {

    /*
    获取列表红色图书
    */
    articleInfo(articleId) {
        return request({
            url: `${api_name}/info/${articleId}`,
            method: 'get'
        })
    }

}
